/**
 * PlanIndicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlanIndicatorResponseDto } from './plan-indicator-response';


export interface ParentPlanIndicatorResponseDto { 
    id: string;
    name: string;
    dataFabricKey: string;
    calculable?: boolean;
    calculationStrategy?: ParentPlanIndicatorResponseDto.CalculationStrategyEnum;
    supportedRelationshipLevels?: Array<string>;
    planIndicators: Array<PlanIndicatorResponseDto>;
}
export namespace ParentPlanIndicatorResponseDto {
    export const CalculationStrategyEnum = {
        Standard: 'STANDARD',
        Inverse: 'INVERSE'
    } as const;
    export type CalculationStrategyEnum = typeof CalculationStrategyEnum[keyof typeof CalculationStrategyEnum];
}


